import React from 'react';
import { Stack, Typography } from '@mui/material';

const SectionTitle: React.FC<{ id: string; children: React.ReactNode; aside?: React.ReactNode }> = ({ id, children, aside }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 1.5 }} useFlexGap flexWrap="wrap">
    <Typography id={id} component="h2" sx={{ fontSize: 16, fontWeight: 600 }}>
      {children}
    </Typography>
    {aside}
  </Stack>
);

export default SectionTitle;
